import "./src/styles/global.css"
import React from "react";
import type { GatsbySSR } from "gatsby";
import ScrollTopTop from "./src/components/ScrollToTop";
import FloatingCallButton from "./src/components/FloatingButton";

// Development-only guard to avoid mini-css-extract-plugin HMR errors
if (typeof window !== "undefined" && process.env.NODE_ENV === "development") {
  // Only set if not already defined to avoid clobbering
  if (!(window as any).__webpack_reload_css__) {
    (window as any).__webpack_reload_css__ = () => {
      try {
        const prefix = window.location.protocol + "//" + window.location.host;
        const links = document.querySelectorAll('link[rel="stylesheet"]');
        links.forEach(link => {
          // Only operate on links that have an href
          const href = (link as HTMLLinkElement).getAttribute('href');
          if (!href) return;
          // If the stylesheet is from this origin, try to remove safely
          if (href.startsWith(prefix) && link.parentNode) {
            try {
              // Clone and replace pattern used by HMR; remove old link safely
              const newLink = link.cloneNode() as HTMLLinkElement;
              newLink.href = href.split('?')[0] + '?t=' + Date.now();
              newLink.onload = () => {
                if (link.parentNode) link.parentNode.removeChild(link);
              };
              link.parentNode.insertBefore(newLink, link.nextSibling);
            } catch (e) {
              // ignore individual link errors
            }
          }
        });
      } catch (e) {
        // swallow any errors to avoid breaking HMR
        // console.warn('CSS HMR guard error', e);
      }
    };
  }
}

export const wrapPageElement: GatsbySSR["wrapPageElement"] = ({ element }) => {
  return (
    <>
      <FloatingCallButton />
      <ScrollTopTop />
      {element}
    </>
  );
};
